export enum CONTROL_TYPE_ENUM {
    RADIO = 'radio',
    MULTI_CHECKBOX = 'multi-checkbox',
    SELECT = 'select',
    MULTI_SELECT = 'multi-select'
}